import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechInsightsDashboardPage } from './TechInsightsDashboardPage';

const techInsightsPageOverride = techInsightsPlugin
  .getExtension('page:tech-insights')
  .override({
    factory(originalFactory) {
      return originalFactory({
        params: {
          path: '/tech-insights',
          loader: async () => <TechInsightsDashboardPage />,
        },
      });
    },
  });

export const techInsightsModule = createFrontendModule({
  pluginId: 'tech-insights',
  extensions: [techInsightsPageOverride],
});
